import React, { ReactNode } from 'react';
import styles from './assets/seance-list-screen.module.scss';
import classNames from 'classnames';
import SeancesGrid from './components/SeancesGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import AdminLayout from 'src/components/layout/RoleLayout';
import { ISeance } from 'src/types/seance';
import CreateSubstitutionButton from './components/CreateSubstitutionButton';
import Loader from '../../../../../../components/Loader';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';

export interface StateProps {
    data: Paginated<ISeance>;
    inProgressCSV: boolean;
    inProgress: boolean;
    providers: SelectObject[];
    districts: SelectObject[];
    vendors: SelectObject[];
    students: SelectObject[];
    serviceTypes: SelectObject[];
    serviceLocations: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getStudents: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getServiceLocations: (params: QueryParams) => void;
}

export interface OwnProps {}
export interface StateParams {
    columnOpen: boolean;
}
export interface Props extends StateProps, DispatchProps, OwnProps {}

class SeanceListScreen extends React.Component<Props, StateParams> {
    constructor(props: Props) {
        super(props);
        this.state = {
            columnOpen: false,
        };
    }
    componentDidMount() {
        this.props.getProviders({
            page: 1,
            itemsPerPage: 9000,
        });
        this.props.getStudents({
            page: 1,
            itemsPerPage: 9000,
        });
        this.props.getVendors({
            page: 1,
            itemsPerPage: 9000,
        });
        this.props.getDistricts({
            page: 1,
            itemsPerPage: 9000,
        });
        this.props.getServiceLocations({
            page: 1,
            itemsPerPage: 9000,
        });
        this.props.getServiceTypes({
            page: 1,
            itemsPerPage: 9000,
        });
    }

    public render(): ReactNode {
        const {
            data,
            getData,
            providers,
            getDataCsv,
            students,
            serviceTypes,
            serviceLocations,
            districts,
            vendors,
            inProgress,
        } = this.props;

        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();
        return (
            <AdminLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                    <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>
                        SESSIONS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    <CreateSubstitutionButton />
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <SeancesGrid
                        columnOpen={this.state.columnOpen}
                        setColumnOpen={(data: boolean) => {
                            this.setState({ ...this.state, columnOpen: data });
                        }}
                        vendors={vendors}
                        districts={districts}
                        students={students}
                        serviceTypes={serviceTypes}
                        serviceLocations={serviceLocations}
                        providers={providers}
                        data={data}
                        getData={getData}
                        getDataCsv={getDataCsv}
                        inProgressCSV={this.props.inProgressCSV}
                    />
                </div>
            </AdminLayout>
        );
    }
}

export default SeanceListScreen;
